import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

const initialForm = { firstName: "", lastName: "", email: "", subject: "Order question", message: "" };

function Contact() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    document.title = `Contact | ${siteConfig.brandName}`;
  }, []);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const submit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!form.firstName.trim()) nextErrors.firstName = "Enter your first name.";
    if (!form.lastName.trim()) nextErrors.lastName = "Enter your last name.";
    if (!/^\S+@\S+\.\S+$/.test(form.email)) nextErrors.email = "Enter a valid email.";
    if (form.message.trim().length < 10) nextErrors.message = "Tell us a little more (at least 10 characters).";
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }
    setIsSubmitting(true);
    await new Promise((resolve) => window.setTimeout(resolve, 650));
    setIsSubmitting(false);
    setSubmitted(true);
    setForm(initialForm);
  };

  return (
    <main className="contact-page">
      <header>
        <nav aria-label="Breadcrumb"><Link to="/">Home</Link><span>/</span><span>Contact</span></nav>
        <p className="eyebrow">Help &amp; contact</p>
        <h1>How can we help?</h1>
      </header>

      <div className="contact-page__layout">
        <aside>
          <p className="eyebrow">Start here</p>
          <h2>Answers, without the wait.</h2>
          <nav aria-label="Customer service pages">
            <Link to="/shipping">Delivery <FiArrowRight /></Link>
            <Link to="/returns">Returns &amp; refunds <FiArrowRight /></Link>
            <Link to="/faqs">FAQs <FiArrowRight /></Link>
            <Link to="/privacy">Privacy <FiArrowRight /></Link>
            <Link to="/cookies">Cookie policy <FiArrowRight /></Link>
            <Link to="/terms">General conditions <FiArrowRight /></Link>
          </nav>
          <div>
            <p><span>Email</span><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a></p>
            <p><span>Company</span>{siteConfig.business.legalName}</p>
            <p><span>Address</span>{siteConfig.contact.address}</p>
            <p><span>Response time</span>Usually within one business day</p>
          </div>
        </aside>

        <section>
          {submitted ? (
            <div className="contact-success" role="status">
              <FiCheck />
              <h2>Message received.</h2>
              <p>Thank you. This demo form has been validated successfully.</p>
              <button type="button" onClick={() => setSubmitted(false)}>Send another message</button>
            </div>
          ) : (
            <form onSubmit={submit} noValidate>
              <p className="eyebrow">Send us a message</p>
              <h2>We’re here to help.</h2>
              <div className="contact-fields">
                {[
                  ["firstName", "First name", "text"],
                  ["lastName", "Last name", "text"],
                  ["email", "Email address", "email"],
                ].map(([name, label, type]) => (
                  <label key={name} className={name === "email" ? "wide" : ""}>
                    <span>{label}</span>
                    <input name={name} type={type} value={form[name]} onChange={update} aria-invalid={Boolean(errors[name])} />
                    {errors[name] && <small>{errors[name]}</small>}
                  </label>
                ))}
                <label className="wide">
                  <span>Subject</span>
                  <select name="subject" value={form.subject} onChange={update}>
                    <option>Order question</option><option>Delivery</option><option>Return</option><option>Product &amp; sizing</option><option>Something else</option>
                  </select>
                </label>
                <label className="wide">
                  <span>Message</span>
                  <textarea name="message" rows="7" value={form.message} onChange={update} aria-invalid={Boolean(errors.message)} />
                  {errors.message && <small>{errors.message}</small>}
                </label>
              </div>
              <button type="submit" disabled={isSubmitting}>{isSubmitting ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </section>
      </div>
    </main>
  );
}

export default Contact;
